<template>
  <el-popover trigger="click" v-model="popOverVisible" v-on="$listeners">
    <div class="ly-popover">
      <div class="popover-btn">
        <el-button class="btn-close" @click="popOverVisible = false" />
      </div>
      <div class="popover-content">
        <slot name="content"></slot>
      </div>
    </div>
    <el-button slot="reference" class="icon-WarningCircle" />
  </el-popover>
</template>

<script>
export default {
  data() {
    return {
      popOverVisible: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.ly-popover {
  .popover {
    &-btn {
      text-align: right;
      .el-button {
        width: auto;
        padding: 0;
        border: 0;
        &:hover {
          background: transparent;
        }
        &::after {
          font : {
            family: "icomoon";
            size: 18px;
          }
          content: "\ec09";
        }
      }
    }
    &-content {
      font-size: $--font-size-small;
      line-height: 1.5;
      .info {
        padding-bottom: 8px;
      }
    }
  }
}
::v-deep {
  .el-button.icon-WarningCircle {
    padding: 0;
    border: 0;
    color: $--color-primary;
  }
}
</style>
